import { CSSProperties, ReactElement, ReactNode, useMemo } from 'react';
import cc from 'classcat';
import { RowContext, RowContextType } from './RowContext';
import './index.less';

type RowProps = {
  gutterH?: number;
  style?: CSSProperties;
  children?: ReactNode;
  className?: string;
  wrap?: boolean;
  direction?: 'column' | 'row' | 'row-reverse' | 'column-reverse';
  align?: 'center' | 'flex-end' | 'flex-start' | 'baseline';
  gutterV?: number;
  onClick?: () => void;
};

const ROW_GUTTER_HALF = -2;

export const Row = ({
  gutterH,
  style,
  wrap,
  gutterV,
  align,
  direction,
  children,
  className,
  onClick
}: RowProps): ReactElement => {
  const rowStyle = {
    flexDirection: direction,
    flexWrap: wrap && 'wrap',
    alignItems: align,
    rowGap: gutterV,
    marginLeft: gutterH ? gutterH / ROW_GUTTER_HALF : 0,
    marginRight: gutterH ? gutterH / ROW_GUTTER_HALF : 0,
    ...style
  } as CSSProperties;

  const rowContext = useMemo<RowContextType>(
    () => ({ gutter: [gutterH, gutterV] as [number, number], wrap }),
    [gutterH, gutterV, wrap]
  );

  return (
    <RowContext.Provider value={rowContext}>
      <div
        className={cc(['custom__row', { [`${className}`]: className }])}
        style={rowStyle}
        onClick={onClick}
      >
        {children}
      </div>
    </RowContext.Provider>
  );
};
